const API_BASE = import.meta.env.VITE_API_URL ?? "/api/v1";
const TOKEN_KEY = "cerberus-cloud-token";

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: { code: "UNKNOWN", message: res.statusText } }));
    throw new ApiError(res.status, err.error?.code ?? "UNKNOWN", err.error?.message ?? res.statusText);
  }

  if (res.status === 204) return undefined as T;

  const json = await res.json();
  return json.data ?? json;
}

export const api = {
  get: <T>(path: string, params?: Record<string, string | number | undefined>) => {
    const url = new URL(path, "http://localhost");
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        if (v !== undefined) url.searchParams.set(k, String(v));
      }
    }
    return request<T>("GET", `${url.pathname}${url.search}`);
  },
  post: <T>(path: string, body?: unknown) => request<T>("POST", path, body),
  patch: <T>(path: string, body?: unknown) => request<T>("PATCH", path, body),
  del: <T>(path: string) => request<T>("DELETE", path),
};
